import React from 'react';
import { Link } from 'react-router-dom';
import { CTASection } from '../../components/CTASection';
import { ShoppingBag, ExternalLink, Shirt, Tag, Gift, Search } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function ProductCatalogs() {
  const catalogs = [{
    title: 'Apparel A',
    subtitle: 'Company Casuals',
    icon: <Shirt className="w-8 h-8 text-wh-teal" data-id="element-1050" />,
    description: 'Port Authority, Sport-Tek, Cornerstone, Nike Golf, OGIO, Eddie Bauer, Red Kap, and more!',
    link: 'https://www.companycasuals.com/WearHausDesigns/start.jsp',
    color: 'border-wh-teal'
  }, {
    title: 'Apparel B',
    subtitle: 'Sportswear Collection',
    icon: <Tag className="w-8 h-8 text-wh-pink" data-id="element-1051" />,
    description: 'Augusta Sportswear, Badger, Bella+Canvas, DRI DUCK, Fruit of the Loom, Gildan, Hanes, J. America, JERZEES, Next Level, Rabbit Skins, Van Heusen, and more!',
    link: 'https://www.sportswearcollection.com/wearhaus',
    color: 'border-wh-pink'
  }, {
    title: 'Apparel C',
    subtitle: 'Imprintable Apparel',
    icon: <ShoppingBag className="w-8 h-8 text-wh-yellow" data-id="element-1052" />,
    description: 'A4 Adams, Alleson Athletic, American Apparel, Badger Sport, Berne, Dickies, Enza, Just Hoods, KC Caps, Lane Seven, J. America, and more!',
    link: 'https://wearhaus.imprintableapparel.com/',
    color: 'border-wh-yellow'
  }, {
    title: 'Promotional Items',
    subtitle: 'Koozie Group',
    icon: <Gift className="w-8 h-8 text-purple-500" data-id="element-1053" />,
    description: 'Pens, pencils, mugs, key chains, golf balls…anything on which your logo can be printed!',
    link: 'https://www.kooziegroup.com/US/',
    color: 'border-purple-500'
  }];
  return <div className="flex flex-col w-full" data-id="element-1054">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-1055">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1056">
          <div className="flex justify-center mb-6" data-id="element-1057">
            <ShoppingBag className="w-16 h-16 text-white" data-id="element-1058" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1059">
            Product Catalogs
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-1060">
            Finding the right product can sometimes be a daunting process, but
            we're here to help. We offer products from a wide variety of
            suppliers, and we ship nationwide.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-id="element-1061">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1062">
          {/* Intro Note */}
          <div className="max-w-3xl mx-auto text-center mb-16 bg-gray-50 p-8 rounded-xl border border-gray-100" data-id="element-1063">
            <Search className="w-10 h-10 text-gray-400 mx-auto mb-4" data-id="element-1064" />
            <p className="text-lg text-gray-700" data-id="element-1065">
              If you're looking for a product that you don't see in these links,{' '}
              <Link to="/Contact" className="text-wh-pink font-semibold hover:underline" data-id="element-1066">
                contact us
              </Link>{' '}
              and we'll give you a hand!
            </p>
          </div>

          {/* Catalogs Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-1067">
            {catalogs.map((catalog, index) => <div key={index} className={`bg-white rounded-xl p-8 border-t-4 shadow-sm hover:shadow-md transition-shadow flex flex-col h-full ${catalog.color}`} data-id="element-1068">
                <div className="flex items-start justify-between mb-6" data-id="element-1069">
                  <div className="bg-gray-50 p-3 rounded-lg" data-id="element-1070">
                    {catalog.icon}
                  </div>
                  <a href={catalog.link} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 transition-colors" aria-label={`Open ${catalog.title} catalog in new tab`} data-id="element-1071">
                    <ExternalLink className="w-5 h-5" data-id="element-1072" />
                  </a>
                </div>

                <div className="mb-6 flex-grow" data-id="element-1073">
                  <h2 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1074">
                    {catalog.title}
                  </h2>
                  {catalog.subtitle && <p className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-4" data-id="element-1075">
                      {catalog.subtitle}
                    </p>}
                  <p className="text-gray-600 leading-relaxed" data-id="element-1076">
                    {catalog.description}
                  </p>
                </div>

                <div className="mt-auto" data-id="element-1077">
                  <a href={catalog.link} target="_blank" rel="noopener noreferrer" className="w-full" data-id="element-1078">
                    <Button variant="outline" className="w-full justify-center group" data-id="element-1079">
                      View Catalog
                      <ExternalLink className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-1080" />
                    </Button>
                  </a>
                </div>
              </div>)}
          </div>

          {/* Help Section */}
          <div className="bg-wh-teal/5 rounded-2xl p-8 md:p-12 text-center border border-wh-teal/20" data-id="element-1081">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1082">
              Need Help Choosing?
            </h3>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-1083">
              With so many options available, it can be hard to decide. Our team
              can recommend the best products for your specific needs and
              budget.
            </p>
            <Link to="/Contact" data-id="element-1084">
              <Button variant="primary" size="lg" data-id="element-1085">
                Get Expert Advice
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <CTASection data-id="element-1086" />
    </div>;
}